// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.fc-timegrid-slot {
    border-top: 1px solid #EFEFEF !important;
  }
  
  .fc-timegrid-slot-lane {
    border-top: 1px solid #EFEFEF !important;
    border-right: 1px solid #EFEFEF !important;
  }
  
  .fc-timegrid-slot-label {
    border-top: 1px solid #EFEFEF !important;
  }
  /* General styles for scrollbars and cell alignment */

.fc-scroller {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  border-radius: 10px !important;
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

.fc-theme-standard td,
.fc-theme-standard th {
  vertical-align: middle;
  height: 2rem;
}

.fc .fc-toolbar-title {
  font-size: 1rem;
  font-weight: bold; /* Bold header title */
}

.fc .fc-toolbar {
  justify-content: flex-end;
  flex-direction: row-reverse;
  padding: 0 1rem;
}

.fc .fc-toolbar .fc-toolbar-chunk {
  margin-left: 1rem;
}

.fc-today-button:disabled {
  background-color: #ffffff !important;
  color: #3249d7 !important;
  border: 2px solid #3249d7 !important;
  text-transform: capitalize;
  border-radius: 10px !important;
}

.fc-today-button:not(:disabled) {
  background-color: #ffffff !important;
  color: #3249d7 !important;
  border-radius: 10px !important;
  border: 2px solid #3249d7 !important;
  text-transform: capitalize !important;
}

.fc-direction-ltr .fc-button-group > .fc-button:not(:last-child) {
  background-color: #ffffff !important;
  color: #bfc3cb !important;
  border: none !important;
  outline: none !important;
  outline-color: transparent !important;
}

.fc-next-button {
  background-color: #ffffff !important;
  color: #bfc3cb !important;
  outline: none !important;
  outline-color: transparent !important;
}

.fc .fc-daygrid-event {
  min-height: auto;
  vertical-align: middle;
  line-height: 2rem;
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  background-color: transparent;
  border: 0px solid #bfc3cb;
  color: #bfc3cb !important;
}

.fc-h-event .fc-event-main {
  color: #bfc3cb !important;
  font-style: normal;
}

.fc-timegrid-event .fc-event-main {
  color: #000000;
  font-weight: 500;
  display: flex;
  flex-direction: column;
}

.title-container {
  position: relative;
  top: 10%;
  display: flex;
  flex-direction: row;
}

.fc-day-today {
  background-color: #ffffff !important;
}

.fc-col-header-cell-cushion {
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  color: #000000 !important;
}

.fc-col-header-cell.fc-day-today .fc-col-header-cell-cushion {
  height: auto !important;
  background-color: #3249d7 !important;
  color: #ffffff !important; /* Text color for today's date */
  margin: 10px;
  padding: 5px 10px;
  border-radius: 10px;
}
.fc-theme-standard th {
  vertical-align: middle;
  height: 68px;
}

.fc-timegrid-slot-label {
  font-weight: bold !important;
  background-color: #ffffff !important;

}

.fc-timegrid-slot {
  height: 52px !important;
  font-weight: bold !important;
  font-size: 12px !important;
  

}

.fc-timegrid-slot-lane{
  font-size: 12px !important;
  font-weight: bold !important;
  

}
.fc-timegrid-axis-frame {
  background-color: #EEEEEE !important;
  font-weight: bold !important;
  font-size: 12px !important;

}
.fc .fc-daygrid-day-frame{
  background-color: #EEEEEE !important;
}
.fc-col-header-cell,
.fc-daygrid-day {
  background-color: #ffffff !important;
}

.fc .fc-now-indicator {
  border-top: 2px solid red !important; /* Change line thickness and color */
}
.fc .fc-now-indicator-line {
  background-color: red !important; /* Change line color */
  height: 2px !important; /* Change line thickness */
}
.fc .fc-timegrid-now-indicator-line{
  border-width: 2px 0 0 !important;
}
.fc .fc-timegrid-now-indicator-arrow {
  display: none !important;
}
.fc .fc-media-screen .fc-direction-ltr .fc-theme-standard{
  background-color: #ffffff !important;

}

.fc .fc-scrollgrid-liquid {
  height: 100%;
  background-color: #ffffff !important;
}

.fc-event {
  margin: 2px !important; /* Space between events */
}`, "",{"version":3,"sources":["webpack://./src/modules/Events/WeekView/Style/CalendarComponent.css"],"names":[],"mappings":";AACA;IACI,wCAAwC;EAC1C;;EAEA;IACE,wCAAwC;IACxC,0CAA0C;EAC5C;;EAEA;IACE,wCAAwC;EAC1C;EACA,qDAAqD;;AAEvD;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB,EAAE,sBAAsB;AAC3C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;EACpC,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB,EAAE,gCAAgC;EAC3D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;;AAEtC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;;;AAG5B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;;;AAG9B;AACA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;;AAE5B;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC,EAAE,oCAAoC;AAC5E;AACA;EACE,gCAAgC,EAAE,sBAAsB;EACxD,sBAAsB,EAAE,0BAA0B;AACpD;AACA;EACE,gCAAgC;AAClC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oCAAoC;;AAEtC;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,sBAAsB,EAAE,yBAAyB;AACnD","sourcesContent":["\n.fc-timegrid-slot {\n    border-top: 1px solid #EFEFEF !important;\n  }\n  \n  .fc-timegrid-slot-lane {\n    border-top: 1px solid #EFEFEF !important;\n    border-right: 1px solid #EFEFEF !important;\n  }\n  \n  .fc-timegrid-slot-label {\n    border-top: 1px solid #EFEFEF !important;\n  }\n  /* General styles for scrollbars and cell alignment */\n\n.fc-scroller {\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n  border-radius: 10px !important;\n  scrollbar-width: thin;\n  scrollbar-color: #888 #f1f1f1;\n}\n\n.fc-theme-standard td,\n.fc-theme-standard th {\n  vertical-align: middle;\n  height: 2rem;\n}\n\n.fc .fc-toolbar-title {\n  font-size: 1rem;\n  font-weight: bold; /* Bold header title */\n}\n\n.fc .fc-toolbar {\n  justify-content: flex-end;\n  flex-direction: row-reverse;\n  padding: 0 1rem;\n}\n\n.fc .fc-toolbar .fc-toolbar-chunk {\n  margin-left: 1rem;\n}\n\n.fc-today-button:disabled {\n  background-color: #ffffff !important;\n  color: #3249d7 !important;\n  border: 2px solid #3249d7 !important;\n  text-transform: capitalize;\n  border-radius: 10px !important;\n}\n\n.fc-today-button:not(:disabled) {\n  background-color: #ffffff !important;\n  color: #3249d7 !important;\n  border-radius: 10px !important;\n  border: 2px solid #3249d7 !important;\n  text-transform: capitalize !important;\n}\n\n.fc-direction-ltr .fc-button-group > .fc-button:not(:last-child) {\n  background-color: #ffffff !important;\n  color: #bfc3cb !important;\n  border: none !important;\n  outline: none !important;\n  outline-color: transparent !important;\n}\n\n.fc-next-button {\n  background-color: #ffffff !important;\n  color: #bfc3cb !important;\n  outline: none !important;\n  outline-color: transparent !important;\n}\n\n.fc .fc-daygrid-event {\n  min-height: auto;\n  vertical-align: middle;\n  line-height: 2rem;\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 600;\n  background-color: transparent;\n  border: 0px solid #bfc3cb;\n  color: #bfc3cb !important;\n}\n\n.fc-h-event .fc-event-main {\n  color: #bfc3cb !important;\n  font-style: normal;\n}\n\n.fc-timegrid-event .fc-event-main {\n  color: #000000;\n  font-weight: 500;\n  display: flex;\n  flex-direction: column;\n}\n\n.title-container {\n  position: relative;\n  top: 10%;\n  display: flex;\n  flex-direction: row;\n}\n\n.fc-day-today {\n  background-color: #ffffff !important;\n}\n\n.fc-col-header-cell-cushion {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 18px;\n  text-align: center;\n  color: #000000 !important;\n}\n\n.fc-col-header-cell.fc-day-today .fc-col-header-cell-cushion {\n  height: auto !important;\n  background-color: #3249d7 !important;\n  color: #ffffff !important; /* Text color for today's date */\n  margin: 10px;\n  padding: 5px 10px;\n  border-radius: 10px;\n}\n.fc-theme-standard th {\n  vertical-align: middle;\n  height: 68px;\n}\n\n.fc-timegrid-slot-label {\n  font-weight: bold !important;\n  background-color: #ffffff !important;\n\n}\n\n.fc-timegrid-slot {\n  height: 52px !important;\n  font-weight: bold !important;\n  font-size: 12px !important;\n  \n\n}\n\n.fc-timegrid-slot-lane{\n  font-size: 12px !important;\n  font-weight: bold !important;\n  \n\n}\n.fc-timegrid-axis-frame {\n  background-color: #EEEEEE !important;\n  font-weight: bold !important;\n  font-size: 12px !important;\n\n}\n.fc .fc-daygrid-day-frame{\n  background-color: #EEEEEE !important;\n}\n.fc-col-header-cell,\n.fc-daygrid-day {\n  background-color: #ffffff !important;\n}\n\n.fc .fc-now-indicator {\n  border-top: 2px solid red !important; /* Change line thickness and color */\n}\n.fc .fc-now-indicator-line {\n  background-color: red !important; /* Change line color */\n  height: 2px !important; /* Change line thickness */\n}\n.fc .fc-timegrid-now-indicator-line{\n  border-width: 2px 0 0 !important;\n}\n.fc .fc-timegrid-now-indicator-arrow {\n  display: none !important;\n}\n.fc .fc-media-screen .fc-direction-ltr .fc-theme-standard{\n  background-color: #ffffff !important;\n\n}\n\n.fc .fc-scrollgrid-liquid {\n  height: 100%;\n  background-color: #ffffff !important;\n}\n\n.fc-event {\n  margin: 2px !important; /* Space between events */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
